import React, { useEffect, useState, useRef } from "react";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { vasthuUrl } from "../component/Api";
import chatingbg from ".././images/chatingbg.jpg";
import { useTranslation } from "react-i18next";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Toast from "../component/Toast";

let stompClient = null;

const ChatRoom = () => {
  const token = window.sessionStorage.getItem("token");
  const userId = window.sessionStorage.getItem("userId");
  const role = window.sessionStorage.getItem("role");
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [chatData, setChatData] = useState("");
  const [privateChats, setPrivateChats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [connected, setConnected] = useState(false);
  const [duration, setDuration] = useState();
  const [countDown, setCountDown] = useState(0);
  const [isTimerStarted, setIsTimerStarted] = useState(false);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState({
    username: "",
    receivername: "",
    connected: false,
    message: "",
  });
  console.log("userData", userData);

  const chatEndView = useRef(null);

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toastTrigger, setToastTrigger] = useState(0);

  const alert = (msg) => {
    setMessage(msg);
    setToastTrigger((prev) => prev + 1);
  };

  const [openModal, setOpenModal] = useState(false);

  const showModal = () => setOpenModal(true);
  const closeModal = () => {
    setOpenModal(false);
    window.history.pushState(null, "", window.location.href);
  };

  const handleBackPage = () => hangUp();

  useEffect(() => {
    if (privateChats.length === 1 && isTimerStarted && countDown > 0) {
      const timer = setInterval(() => {
        setCountDown((prev) => {
          if (prev <= 1) {
            clearInterval(timer); // stop timer if countdown reaches 0
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer); // clear on unmount or dependency change
    }
  }, [isTimerStarted]);

  const formatTime = (seconds) => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  useEffect(() => {
    const fetchChatDetails = async () => {
      try {
        setLoading(true);
        const endpoint =
          role === "ROLE_USER"
            ? `/initiateChat/getchatdetails/${userId}`
            : `/initiateChat/getchatdetailsforconsultant/${userId}`;
        const response = await vasthuUrl.get(endpoint, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setChatData(response.data);

        if (response.data) {
          const username = window.sessionStorage.getItem("authname");
          const receivername =
            role === "ROLE_USER"
              ? response.data.clientName
              : response.data.customerName;

          setUserData((prev) => ({ ...prev, username, receivername }));
          registerUser(username);
        }
      } catch (err) {
        setError("Failed to fetch chat details.");
      } finally {
        setLoading(false);
      }
    };

    fetchChatDetails();
  }, [token, role, userId]);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const res = await vasthuUrl.get(
          `/initiateChat/getChatCurrentSatus/${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.status !== "in-progress") {
          if (role === "ROLE_USER") {
            alert(t("CON.NO.CON"));
            setMessageType("error");
            setTimeout(() => navigate("/chathistory"), 4000);
          } else {
            navigate("/");
          }
        }
      } catch (err) {
        setError("Failed to fetch chat status.");
      }
    };

    fetchStatus();
    const intervalId = setInterval(fetchStatus, 1000);
    return () => clearInterval(intervalId);
  }, [token, role, userId, navigate, t]);

  useEffect(() => {
    if (chatEndView.current) {
      chatEndView.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [privateChats]);

  useEffect(() => {
    if (privateChats.length === 1) {
      if (role !== "ROLE_USER") {
        const response = vasthuUrl
          .put(
            `/initiateChat/updateChatStatus/${chatData.id}`,
            {
              chatFromId: chatData.chatFromId,
              chatToId: chatData.chatToId,
              status: "CONNECTED",
            },
            { params: { isConnected: true } }
          )
          .then((res) => {
            if (res.data) {
              console.log("res.data", res.data);
              setDuration(res.data.proposedChatDuration);
            }
          });
        console.log("chatData", chatData);
      }
      setCountDown(chatData.proposedChatDuration);
      setIsTimerStarted(true);
    }
  }, [privateChats.length]);

  useEffect(() => {
    if (duration) {
      const timeoutId = setTimeout(() => hangUp(), duration * 1000);
      return () => clearTimeout(timeoutId);
    }
  }, [duration]);

  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      showModal();
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const registerUser = (username) => connect(username);

  const connect = (username) => {
    const chatUrl = `${process.env.REACT_APP_BAS_URL}ws`;
    stompClient = new Client({
      webSocketFactory: () => new SockJS(chatUrl),
      onConnect: () => onConnected(username),
      onStompError: onError,
      debug: (msg) => console.log(msg),
    });
    stompClient.activate();
  };

  const onConnected = (username) => {
    setUserData((prev) => ({ ...prev, connected: true }));
    setConnected(true);
    stompClient.subscribe(`/user/${username}/private`, onPrivateMessage);
    userJoin(username);
  };

  const onError = (err) => {
    setError("WebSocket connection failed.");
    console.error("WebSocket Error:", err);
  };

  const userJoin = (username) => {
    const chatMessage = { senderName: username, status: "JOIN" };
    stompClient.publish({
      destination: "/app/message",
      body: JSON.stringify(chatMessage),
    });
  };

  const onPrivateMessage = (payload) => {
    const data = JSON.parse(payload.body);
    setPrivateChats((prev) => [...prev, data]);
  };

  const sendPrivateMessage = async () => {
    if (stompClient && userData.message) {
      const chatMessage = {
        senderName: userData.username,
        receiverName: userData.receivername,
        message: userData.message,
        meetingCode: chatData.meetingCode,
        role,
      };

      setPrivateChats((prev) => [...prev, chatMessage]);
      stompClient.publish({
        destination: "/app/private-message",
        body: JSON.stringify(chatMessage),
      });

      try {
        await vasthuUrl.post(`/saveChats`, chatMessage, {
          params: { meetingCode: chatData.meetingCode },
          headers: { Authorization: `Bearer ${token}` },
        });
      } catch (err) {
        console.error("Error saving chat:", err);
      }

      // setUserData((prev) => ({ ...prev, message: "" }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({ ...prev, [name]: value }));
  };

  const hangUp = async () => {
    try {
      await vasthuUrl.put(`/initiateChat/disconnectChat/${chatData.id}`);
    } catch (err) {
      console.error("Error disconnecting chat:", err);
    }
    if (stompClient) stompClient.deactivate();
    if (role === "ROLE_USER") navigate("/chathistory");
    else navigate("/");
  };

  return (
    <div style={{ padding: "20px", margin: "auto" }}>
      <Toast msg={message} type={messageType} trigger={toastTrigger} />
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" variant="warning" />
        </div>
      ) : connected ? (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "40px",
            }}
            className="mb-2"
          >
            <div className="text-center">
              <h2 style={{ color: "red", height: "24px" }}>
                {formatTime(countDown)}
              </h2>
              <h6 style={{ color: "#6f6a6a" }}>HH:MM:SS</h6>
            </div>
            <div>
              <Button
                variant="warning"
                style={{ width: "fit-content" }}
                onClick={showModal}
              >
                {t("CON.HANGUP.BTN")}
              </Button>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "82vh",
              padding: "0px 7px",
              backgroundImage: `url(${chatingbg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundBlendMode: "overlay",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
              boxShadow: "0 10px 20px rgba(0, 0, 0, 0.3)",
            }}
          >
            <ul style={{ listStyleType: "none", padding: 0, overflow: "auto" }}>
              {privateChats.length > 0 ? (
                privateChats.map((chat, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      justifyContent:
                        chat.senderName === userData.username
                          ? "flex-end"
                          : "flex-start",
                      margin: "10px 0",
                      overflowWrap: "anywhere",
                    }}
                  >
                    <div
                      style={{
                        padding: "10px",
                        backgroundColor:
                          chat.senderName === userData.username
                            ? "#d1e7dd"
                            : "#f8d7da",
                        borderRadius: "10px",
                      }}
                    >
                      {chat.senderName === userData.username ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: chat.message.replaceAll("\n", "<br />"),
                          }}
                        />
                      ) : (
                        <>
                          <strong>{chat.senderName}: </strong>
                          <span
                            dangerouslySetInnerHTML={{
                              __html: chat.message.replaceAll("\n", "<br />"),
                            }}
                          />
                        </>
                      )}
                    </div>
                  </li>
                ))
              ) : role === "ROLE_USER" ? (
                <p
                  style={{
                    textAlign: "center",
                    color: "red",
                    marginTop: "20px",
                  }}
                >
                  {t("USR.WAIT.FST.CHAT.MSG.ALT")}
                </p>
              ) : null}
              <div ref={chatEndView} />
            </ul>

            <div className="p-2 text-center d-flex flex-row justify-content-center">
              <textarea
                type="text"
                name="message"
                value={userData.message}
                onChange={handleInputChange}
                placeholder={t("USR.TYPE.MSG.PLHDER")}
                className="chat_input_feild"
                rows="1"
                disabled={role === "ROLE_USER" && privateChats.length === 0}
              />
              <Button
                // onClick={sendPrivateMessage}
                onClick={() => {
                  sendPrivateMessage();
                  setUserData((prev) => ({ ...prev, message: "" }));
                }}
                disabled={role === "ROLE_USER" && privateChats.length === 0}
                className="chat_send_btn all_btn1"
              >
                {t("USR.SEND.BTN")}
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center">
          <Spinner animation="border" variant="warning" />
        </div>
      )}

      <Modal show={openModal} onHide={closeModal} className="all_border">
        <Modal.Header closeButton className="all_background">
          <h3>{t("CON.ALERT")}</h3>
        </Modal.Header>
        <Modal.Body>
          <h6>{t("CHT.END.TXT")}</h6>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <Button className="all_btn" onClick={closeModal}>
            {t("USR.VSH.HFTAB.MDL.CNF.BTN.CNC")}
          </Button>
          <Button className="all_btn" onClick={handleBackPage}>
            {t("USR.VSH.HFTAB.MDL.CNF.BTN.CNF")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChatRoom;
